Wee.fn.make('general', {
	init: function() {
		Wee.easySlide.init({
			elementRef: 'generalQuote',
			trackerRef: 'dot'
		});
	}
});
